import { aspenApiConfig } from '../../aspen-api-config'
import { OpenAPI } from '../client'

export function createTaskSocket(taskId: string) {
    let ASPEN_WSS_URL = aspenApiConfig.aspenApiUrl?.replace(new RegExp(/^http/), 'ws').concat('/tasks/ws/')
    const url = ASPEN_WSS_URL + taskId
    const socket = new WebSocket(url)
    socket.onopen = () => {
        socket.send(JSON.stringify({ token: OpenAPI.TOKEN }))
    }
    return socket
}
